import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import styles from './ModalPortal.module.css';

export function ModalPortal({ children, onClose, isMobile = false }) {
  useEffect(() => {
    const originalOverflow = document.body.style.overflow;
    const originalPosition = document.body.style.position;
    const originalTop = document.body.style.top;
    
    const scrollY = window.scrollY;
    
    document.body.style.overflow = 'hidden';
    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollY}px`;
    document.body.style.width = '100%';
    
    return () => {
      document.body.style.overflow = originalOverflow;
      document.body.style.position = originalPosition;
      document.body.style.top = originalTop;
      document.body.style.width = '';
      window.scrollTo(0, scrollY);
    };
  }, []);

  return createPortal(
    <div
      className={isMobile ? styles.modalPortalOverlayMobile : styles.modalPortalOverlay}
      onClick={onClose}
    >
      <div
        className={isMobile ? styles.modalPortalContentMobile : styles.modalPortalContent}
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
}
